import { ColumnTypes } from '../../../src/components/table/columnTypes';

import { BasicColumnTypes, SemanticTypes } from '@opengov/ogql-types';
import { IReportColumn } from '@opengov/reporting-types/src/reportColumns-immer';

export const semanticTypesToColumnTypesMapping = {
  [SemanticTypes.Account.Ignored]: ColumnTypes.Text,
  [SemanticTypes.Check.Ali]: ColumnTypes.Text,
  [SemanticTypes.Check.Amount]: ColumnTypes.Currency,
  [SemanticTypes.Check.CheckNo]: ColumnTypes.Number,
  [SemanticTypes.Check.Date]: ColumnTypes.Date,
  [SemanticTypes.Check.Department]: ColumnTypes.Text,
  [SemanticTypes.Check.DocumentID]: ColumnTypes.Number,
  [SemanticTypes.Check.Expense]: ColumnTypes.Currency,
  [SemanticTypes.Check.ExpenseType]: ColumnTypes.Text,
  [SemanticTypes.Check.Fund]: ColumnTypes.Text,
  [SemanticTypes.Check.PaidTo]: ColumnTypes.Text,
  [SemanticTypes.Check.Program]: ColumnTypes.Text,
  [SemanticTypes.Check.VendorCity]: ColumnTypes.Text,
  [SemanticTypes.Currency.USD]: ColumnTypes.Currency,
  [SemanticTypes.Currency.GBP]: ColumnTypes.Currency,
  [SemanticTypes.Currency.CAD]: ColumnTypes.Currency,
  [SemanticTypes.Dimension.Column]: ColumnTypes.Text,
  [SemanticTypes.Dimension.Key]: ColumnTypes.Text,
  [SemanticTypes.Finance.Assets]: ColumnTypes.Currency,
  [SemanticTypes.Finance.Equities]: ColumnTypes.Currency,
  [SemanticTypes.Finance.Expenses]: ColumnTypes.Currency,
  [SemanticTypes.Finance.Liabilities]: ColumnTypes.Currency,
  [SemanticTypes.Finance.Revenues]: ColumnTypes.Currency,
  [SemanticTypes.Geometry.Linestring]: ColumnTypes.Text,
  [SemanticTypes.Geometry.MultiLinestring]: ColumnTypes.Text,
  [SemanticTypes.Geometry.MultiPoint]: ColumnTypes.Number,
  [SemanticTypes.Geometry.MultiPolygon]: ColumnTypes.Number,
  [SemanticTypes.Geometry.Point]: ColumnTypes.Number,
  [SemanticTypes.Geometry.Polygon]: ColumnTypes.Number,
  [SemanticTypes.Hierarchy.Attribute]: ColumnTypes.Text,
  [SemanticTypes.Metadata.AllConcat]: ColumnTypes.Text,
  [SemanticTypes.Metadata.Description]: ColumnTypes.Text,
  [SemanticTypes.Metadata.Label]: ColumnTypes.Text,
  [SemanticTypes.Numeric.Percentage]: ColumnTypes.Percent,
  [SemanticTypes.Numeric.PositiveDecimal]: ColumnTypes.Number,
  [SemanticTypes.Numeric.PositiveInteger]: ColumnTypes.Number,
  [SemanticTypes.Period.FiscalMonth]: ColumnTypes.Period,
  [SemanticTypes.Period.FiscalQuarter]: ColumnTypes.Date,
  [SemanticTypes.Period.FiscalYear]: ColumnTypes.Year,
  [SemanticTypes.Calendar.GregorianYear]: ColumnTypes.Year,
  [SemanticTypes.Period.GregorianMonthNumeric]: ColumnTypes.Date,
  [SemanticTypes.Period.GregorianYearNumeric]: ColumnTypes.Date,
  [SemanticTypes.StructuredDataType.MonetaryAmount]: ColumnTypes.Currency,
  [SemanticTypes.StructuredDataType.MonetaryAmountHttps]: ColumnTypes.Currency,
  [SemanticTypes.SystemGenerated]: ColumnTypes.Text
};

export const BasicColumnTypesToColumnTypesMapping = {
  [BasicColumnTypes.Period]: ColumnTypes.Year,
  [BasicColumnTypes.Currency]: ColumnTypes.Currency,
  [BasicColumnTypes.Date]: ColumnTypes.Date,
  [BasicColumnTypes.Year]: ColumnTypes.Year,
  [BasicColumnTypes.DayInterval]: ColumnTypes.Number,
  [BasicColumnTypes.YearInterval]: ColumnTypes.Number,
  [BasicColumnTypes.Numeric]: ColumnTypes.Number,
  [BasicColumnTypes.Percent]: ColumnTypes.Percent,
  [BasicColumnTypes.Text]: ColumnTypes.Text,
  [BasicColumnTypes.Boolean]: ColumnTypes.Boolean
};

export const getTableColumnTypeFromReportColumnType = (column: IReportColumn): ColumnTypes => {
  if (column.type === BasicColumnTypes.Boolean) {
    return ColumnTypes.Boolean;
  }

  // If there is no basic type, then we default to Text.
  const baseColumnType = column.type || ColumnTypes.Text;

  // We get the semantic type here, if one exists.
  const columnSemanticTypes: any[] = column.semanticTypes; // List<IOgqlSemanticType>
  let semanticColumnType;

  if (columnSemanticTypes && columnSemanticTypes.length > 0) {
    if (columnSemanticTypes[0].type) {
      semanticColumnType = columnSemanticTypes[0].type;
    } else {
      semanticColumnType = columnSemanticTypes.find((type) => !!semanticTypesToColumnTypesMapping[type]);
    }
  }

  // Which brings us to concrete OGQL column type.
  const ogqlColumnType = semanticColumnType ? semanticColumnType : baseColumnType;

  // Now we pull the table ColumnType based on the OGQL column type.
  // This can be null if we're only dealing with a basic type.
  const mappedSemanticType = semanticTypesToColumnTypesMapping[ogqlColumnType];

  // And so we check to see if we have a mapped type. If we do, we're saying that we should use the semantic type.
  // If we don't have a semantic type, then we should pull the table's ColumnType from the basic OGQL types.
  const columnType = mappedSemanticType ? mappedSemanticType : BasicColumnTypesToColumnTypesMapping[ogqlColumnType];

  // And if everything is weird and we somehow have no types at this point, default to Text.
  return columnType ? columnType : ColumnTypes.Text;
};
